<template>
    <div class="text-center py-5 fadeInUp">
        <iframe class="shadow-md"
            :src="getSrc">
        </iframe>
    </div>
</template>

<script>
export default {
    name: "Song",
    props: {
        videoSrc: String
    },
    computed: {
        getSrc() {
            return this.videoSrc
        }
    }
}
</script>

<style lang="scss">
    iframe {
        width: 100%;
        height: 18.75rem;
        border: none;
        border-radius: 7px;
    }
</style>